<template>
  <div class="flex flex-col gap-4">
    <div v-if="title" class="text-foreground text-sm font-semibold leading-5">
      {{ title }}
    </div>
    <div class="flex flex-col gap-1">
      <slot />
    </div>
  </div>
</template>

<script>
export default { name: "SectionBlock", props: { title: String } };
</script>
